import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { TabsProvider } from "@/context/TabsContext";
import { BrandingProvider } from "@/context/BrandingContext";
import Layout from "@/components/Layout";
import TabContent from "@/components/TabContent";
import TenantWelcome from "@/pages/TenantWelcome";
import RootLogin from "@/pages/RootLogin";
import SuperAdmin from "@/pages/SuperAdmin";
import "@/App.css";

function ProtectedShell() {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="h-screen w-screen flex items-center justify-center bg-background">
        <div className="text-muted-foreground text-sm font-mono">Cargando…</div>
      </div>
    );
  }
  if (!user) {
    // No hay sesión → ir al login raíz (sin /c/demo)
    return <Navigate to="/login" replace />;
  }
  return (
    <TabsProvider>
      <Layout>
        <TabContent />
      </Layout>
    </TabsProvider>
  );
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      {/* Login raíz (sin slug en la URL) — split layout con hero de odontología */}
      <Route path="/login" element={<PublicOnly><RootLogin /></PublicOnly>} />

      {/* Tenant welcome / login con slug explícito (compatibilidad y deep-links) */}
      <Route path="/c/superadmin" element={<Navigate to="/superadmin" replace />} />
      <Route path="/c/:slug" element={<PublicOnly><TenantWelcome /></PublicOnly>} />

      {/* Super-admin panel */}
      <Route path="/superadmin" element={<SuperAdmin />} />

      {/* Legacy redirects */}
      <Route path="/register" element={<Navigate to="/login" replace />} />

      {/* App protegida — todas las rutas internas pasan por ProtectedShell con tabs persistentes */}
      <Route path="*" element={<ProtectedShell />} />
    </Routes>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrandingProvider>
          <BrowserRouter>
            <AppRoutes />
            <Toaster richColors position="top-right" />
          </BrowserRouter>
        </BrandingProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
